module.exports = __webpack_public_path__ + "img/SWP_Sword_2H_05.0df8f299.png";